<!--
 * @Author: your name
 * @Date: 2020-11-19 22:13:09
 * @LastEditTime: 2021-01-05 14:41:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/DialogContent/index.vue
-->
<style lang="sass" scoped>
.dialog_content
  display: flex
  flex-direction: column
  height: 100%

.img_box
  text-align: center
  height: 66PX

.logo_img
  height: 100%

.content
  flex: 1
</style>

<template lang="pug">
.dialog_content
  .img_box
    img.logo_img(:src="imgSrc")
  sign-up-page.content(
    v-if="showSignUpPage"
    v-on="$listeners"
    v-bind="$attrs"
  )
  sign-up-success-page(v-else)
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import SignUpPage from './../SignUpPage'
import SignUpSuccessPage from './../SignUpSuccessPage'

@Component({
  components: {
    SignUpPage,
    SignUpSuccessPage
  },

  props: {
    imgSrc: {
      type: String
    },

    showSignUpPage: {
      type: Boolean
    },
  }
})

class DialogContent extends Vue {
}

export default DialogContent
</script>
